import React from 'react'
import { StyleSheet } from 'react-native'

import { Box } from 'widgets/Box'
import { Pressable } from 'widgets/Pressable'
import { Text } from 'widgets/Text'

type TagProps = {
  size?: number
  type: 'badge' | 'circle'
  title: string
  subtitle?: string
  selected: boolean
  onPress?: () => void
}

const styles = StyleSheet.create({
  mt0: {
    marginTop: 0,
  },
  mb0: {
    marginBottom: 0,
  },
})

export const Tag = ({ size = 50, type, title, subtitle, selected, onPress }: TagProps) => {
  return (
    <Pressable disabled={onPress == null} onPress={onPress}>
      {type === 'badge' && (
        <Box
          borderRadius='xs'
          margin={{ bottom: 'smd', horizontal: 'xs' }}
          padding={{ vertical: 'xs', horizontal: 'smd' }}
          backgroundColor={selected ? 'v2primary' : 'greyLight'}
        >
          <Text color={!selected ? 'black' : 'white'} fontSize='sm'>
            {title}
          </Text>
        </Box>
      )}

      {type === 'circle' && (
        <Box
          width={size}
          height={size}
          align='center'
          justifyContent='center'
          borderRadius='xl'
          margin={{ bottom: 'smd', horizontal: 'xs' }}
          backgroundColor={selected ? 'v2primary' : 'greyLight'}
        >
          <Text
            bold
            fontSize='sm'
            align='center'
            numberOfLines={2}
            ellipsizeMode='clip'
            style={styles.mb0}
            color={!selected ? 'black' : 'white'}
          >
            {title === 'Ongoing' ? 'on-going' : title}
          </Text>
          {subtitle && (
            <Text
              fontSize='sm'
              numberOfLines={1}
              ellipsizeMode='clip'
              style={styles.mt0}
              color={!selected ? 'black' : 'white'}
            >
              {subtitle}
            </Text>
          )}
        </Box>
      )}
    </Pressable>
  )
}
